import React from 'react'
import {
  Button,
  Flex,
  Grid,
  layout,
  NewCard,
  Span,
  styled,
  Modal
} from '@fareye/ui'
import { FaChevronDown, FaTruck, MdMessage } from '@fareye/utils'

export const RouteWiseCard = styled.div`
  box-shadow: 0 0 0px 1px rgba(128, 128, 128, 0.3);
  border-radius: 2px;
  padding: 10px;
  background: ${(props: any) => props.theme.colors.white1};
  cursor: pointer;
`

export const RouteContainerGrid = styled(Grid)`
  grid-gap: 2vw;
  justify-content: space-evenly;
  transition: 1s ease;
  overflow: hidden;
  @media (max-width: 2560px) {
    transition: 1s ease;
    grid-gap: 1vw;
    grid-template-columns: repeat(auto-fill, 19%);
  }
  @media (max-width: 1920px) {
    transition: 1s ease;
    grid-gap: 1vw;
    grid-template-columns: repeat(auto-fill, 24%);
  }
  @media (max-width: 1440px) {
    transition: 1s ease;
    grid-gap: 1vw;
    grid-template-columns: repeat(auto-fill, 32.5%);
  }
  @media (max-width: 992px) {
    transition: 1s ease;
    grid-gap: 1vw;
    grid-template-columns: repeat(auto-fill, 49%);
  }
  @media (max-width: 640px) {
    transition: 1s ease;
    grid-gap: 2vw;
    grid-template-columns: minmax(0, 1fr);
  }
  @media (min-width: 2561px) {
    transition: 1s ease;
    grid-gap: 1vw;
    grid-template-columns: repeat(auto-fill, 16%);
  }
`

export const StatusSlider = styled.div`
  margin-bottom: 1px;
`

export const Status: any = styled.div`
  height: 10px;
  border-radius: 2px;
  background: ${(props: any) => props.color.block};
  width: ${(props: any) => `${props.percent}%`};
`

export const TransporterWiseCard = styled(NewCard)`
  background: #fff;
  border-radius: 5px;
  cursor: pointer;
`
export const CarrierWiseCard = styled(NewCard)`
  background: #ffffff;
  box-shadow: 0px 1.6px 3.6px rgba(47, 60, 69, 0.13),
    0px 0.3px 0.9px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  cursor: pointer;
`

export const PerformanceStatus = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 1px 6px;
  margin: 5px 0px;
  gap: 8px;
  background: ${(props: any) => `${props.color}`};
  border-radius: 2px;
`

export const TransporterStatus: any = styled.div`
  height: 6px;
  margin-top: 4px;
  background: ${(props: any) => `rgba(200, 28, 28,${0.2 + props.value / 100})`};
  width: ${(props: any) => `${props.value}%`};
`

export const Breadcrumbs: any = styled(Flex)`
  display: inline-flex;
  width: auto;
`
export const BreadcrumbItem = styled(Button)`
  a {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre;
    color: inherit;
    display: block;
    text-decoration: none;
  }
  ${(props: any) => {
    return !props.disabled
      ? `color: ${props.theme.colors.blue6}`
      : `pointer-events:none`
  }}
`
export const SetFavourite: any = styled(Flex)`
  border-color: #b3b3b3;
  border-width: 1px;
  border-left-width: 0;
  border-style: solid;
  border-color: #b3b3b3;
  border-radius: 0 4px 4px 0;
  padding-right: 10px;
  &:hover {
    border-color: #b3b3b3;
  }
`

export const TimeLine: any = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 15px;
  border-top: 1px solid ${(props: any) => props.theme.colors.gray4};
`

export const NavigatorPrev = styled.div`
  padding: 10px 5px;
  height: 100%;
`
export const NavigatorNext = styled.div`
  padding: 10px 5px;
  height: 100%;
`

export const TimeLineContent: any = styled(Flex)`
  flex: 1;
  flex-wrap: nowrap;
  overflow: auto;
`
export const Stage: any = styled(Flex)`
  padding: 0; // undo to padding: 5px 0 0;
  flex-grow: 1;
  position: relative;
  min-width: 160px;
  .popover {
    display: none;
  }
`
export const IconLine = styled.div`
  position: relative;
  min-height: 30px;
`
export const Icon = styled.div`
  position: relative;
  display: inline-block;
  margin: 3px 0; // undo to margin: 0;
`
export const Line: any = styled.div`
  width: 100%;
  min-width: 160px;
  border: 0px solid transparent;
  border-bottom: ${(props: any) =>
    `2px ${props.borderStyle} ${
      props.theme.colors[props.borderColor]
        ? props.theme.colors[props.borderColor]
        : props.borderColor
    }`};
  &:before {
    content: '';
    display: ${(props: any) => (props.width > 0 ? 'block' : 'none')};
    position: absolute;
    background: ${(props: any) => props.theme.colors.blue7};
    height: 2px;
    width: ${(props: any) => props.width}%;
    min-width: 300px;
  }
`

export const Details: any = styled(Flex)<{ disableTransform: boolean }>`
  position: relative;
  padding: 0px 5px 5px;
  transform: ${({ disableTransform }) =>
    disableTransform ? 'unset' : 'translateX(-10px)'};
  min-height: 2.5em;
`

export const MMStopsDetails: any = styled(Flex)`
  width: auto;
  z-index: 1001;
  position: fixed;
  background: #fff;
  min-width: 150px;
  padding: 10px 15px;
  height: max-content;
  transition: 0.4s ease;
  flex-direction: column;
  box-sizing: border-box;
  box-shadow: 0 0 4px 0px rgb(125, 125, 125);
`

export const PoiDetailContainer: any = styled(Flex)`
  width: 100%;
  padding: 30px 25px;
  flex-direction: column;
  box-sizing: border-box;
`

export const StoppageContainer = styled(Grid)`
  border: 2px solid #fff;
  padding: 10px 8px;
  border-radius: 5px;
  box-shadow: inset 0 0 2px 0px rgba(120, 120, 120, 0.4),
    0 0 3px 1px rgba(120, 120, 120, 0.4);
`

export const EndCirle = styled.div`
  box-sizing: border-box;
  height: 6px;
  width: 6px;
  opacity: 0.9;
  border-radius: 50%;
  background-color: #727272;
`

export const StartCirle = styled.div`
  box-sizing: border-box;
  height: 7px;
  width: 7px;
  border: 1px solid #727272;
  opacity: 0.9;
  border-radius: 50%;
`
export const StoryTimeLine = styled.div`
  box-sizing: border-box;
  height: 14px;
  width: 2px;
  border-radius: 50%;
  border: 1px dotted #979797;
  margin-left: 2px;
  margin-top: -11px;
  margin-bottom: 3px;
`
export const CommantatorIcon = styled(MdMessage)`
  font-size: 22px;
  margin-right: 15px;
  color: ${props => props.theme.colors.blue7};
`

export const InTransitHeaderBody = styled.div<{ childCount: number }>`
  display: grid;
  width: 100%;
  grid-gap: 1em;
  grid-template-areas: ${({ childCount }) =>
    childCount === 3
      ? `'left right''summary-filter summary-filter'`
      : `'left absent' 'summary-filter summary-filter'`};
  align-items: center;
  @media (max-width: 425px) {
    grid-template-areas:
      'right'
      'left'
      'summary-filter';
  }
  @media (min-width: 426px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`

export const TransportedListGrid = styled(Grid)<{ containerStyle: any }>`
  ${({ containerStyle }) => ({ ...containerStyle })}
  grid-gap: 2vw;
  justify-content: space-evenly;
  transition: 1s ease;
  overflow: hidden;
  @media (max-width: 2560px) {
    transition: 1s ease;
    grid-gap: 1vw;
    grid-template-columns: repeat(auto-fill, 19%);
  }
  @media (max-width: 1920px) {
    transition: 1s ease;
    grid-gap: 1vw;
    grid-template-columns: repeat(auto-fill, 24%);
  }
  @media (max-width: 1440px) {
    transition: 1s ease;
    grid-gap: 1vw;
    grid-template-columns: repeat(auto-fill, 32.5%);
  }
  @media (max-width: 992px) {
    transition: 1s ease;
    grid-gap: 1vw;
    grid-template-columns: repeat(auto-fill, 49%);
  }
  @media (max-width: 640px) {
    transition: 1s ease;
    grid-gap: 2vw;
    grid-template-columns: minmax(0, 1fr);
  }
  @media (min-width: 2561px) {
    transition: 1s ease;
    grid-gap: 1vw;
    grid-template-columns: repeat(auto-fill, 16%);
  }
`

export const EtaGrid = styled(Grid)<{ showSummary: boolean }>`
  width: 100%;
  grid-template-areas: ${({ showSummary }) =>
    showSummary ? `'left right' 'summary summary'` : `'left right'`};
  grid-template-columns: '1fr 1fr';
  grid-template-rows: ${({ showSummary }) =>
    showSummary ? '1fr 1fr' : 'unset'};
  width: '100%';
  marginbottom: ${({ showSummary }) => (showSummary ? 'unset' : '1em')};

  @media screen and (max-width: 425px) {
    grid-template-areas: ${({ showSummary }) =>
      showSummary ? `'right' 'left' 'summary'` : `'left'`};
    grid-template-columns: '1fr';
    grid-template-rows: ${({ showSummary }) =>
      showSummary ? '1fr 1fr 1fr' : '1fr'};
  }
`

export const ActiveText = styled.span`
  font-size: 12px;
  color: #0075fa;
  padding: 2px 4px;
`
export const DownIconStyle = styled(FaChevronDown)`
  color: #006491;
`

export const MultiModalHeaderContainer = styled.div`
  display: flex;
  width: 100%;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`

export const SummarFilterWrapper = styled.div`
  max-width: 100vw;
  overflow: auto;
  flex: 5 0 auto;
`

export const SummaryWithModesSelector = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 1em;
  }
`
export const Hr = styled.hr`
  box-sizing: border - box;
  height: 0px;
  width: 100%;
  border: 1px solid #f3f3f3;
`

export const ColorSpan = styled(Span)`
  color: ${props => props.theme.colors[props?.title || 'inherit']};
`
export const RWDSpan: any = styled(Span)`
  @media (max-width: 1920px) {
    font-size: 12px;
  }
  @media (max-width: 1440px) {
    font-size: 10px;
  }
  @media (min-width: 1921px) {
    font-size: 14px;
  }
`
export const FaTruckSt = styled(FaTruck)`
  height: 35.14px;
  width: 112px;
  margin-right: 20px;
  @media (min-width: 3840px) {
    height: 107px;
    width: 341px;
    margin-right: 100px;
  }
`
export const ColFullHeight: any = styled((props: any) => (
  <Flex
    justifyContentSpaceEvenly
    column
    {...props}
    style={{
      width: '100%',
      height: '100%',
      ...props.style,
      boxSizing: 'content-box',
      background: props.color
    }}
  >
    {props.children}
  </Flex>
))`
  ${layout}
  font-weight: 500;
  line-height: 20px;
  font-family: Roboto;
  font-style: normal;
  @media (min-width: 1441px) and (max-width: 3840px) {
    line-height: 40px;
    font-size: 12px;
  }
  @media (min-width: 3841px) {
    line-height: 82px;
    font-size: 12px;
  }
`
export const MoreFilterButton = styled(Button)`
  border: 1px solid #1276d3;
  box-sizing: border-box;
  border-radius: 2px;
  padding: 5px 14px;
  margin: 10px 4px;
  max-height: 34px;
  align-items: center;
  margin-top: auto;
`

export const AddFiltersListingContainer = styled(Modal)`
  @media (max-width: 425px) {
    width: 100%;
  }
`
export const AddFilterListingApplicationButton = styled(Button)`
  justify_content: center;
  align-items: center;
  padding: 5px 16px;
  position: static;
  margin: 4px 6px;
  box-sizing: border-box;
  border-radius: 2px;
`
export const AddFilterListingApplicationButtonLabel = styled(Span)`
  position: static;
  left: 16px;
  top: 10px;
  text-align: center;
`
export const FilterCategoryListing: any = styled(Flex)`
  flex-direction: column;
  margin-right: 4px;
  width: 100%;
  overflow-y: 'scroll';
`
